import React, { useCallback, useEffect, useMemo, useState } from 'react';
import block from 'bem-cn';
import dayjs from 'dayjs';
import PT from 'prop-types';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';

import Copy from 'components/Copy';
import Button from 'components/Button';
import SVG from 'components/SVG';

import { getTimer } from 'shared/helpers/getTimer';

import copySVG from './img/copy.svg'
import timerSVG from './img/timer.svg'

import './BithidePaymentPay.scss';

const b = block('bithide-payment-pay');

const BithidePaymentPay = ({
  onCancelClick,
  onPaidClick,
}) => {
  const { locale } = useSelector(state => state.locale);
  const {
    id,
    replenishmentAddress,
    fromCurrency,
    fromCurrencyAmount,
    validUntil,
  } = useSelector(state => state.payment.depositInitData);

  const [timer, setTimer] = useState('0:00');

  const validDate = useMemo(() => dayjs(validUntil), [validUntil]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(getTimer(validDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [validDate, timer]);



  const handlePaidClick = useCallback(() => {
    onPaidClick(id);
  }, [onPaidClick, id]);

  return (
    <div className={b()}>
      <div className={b('field')}>
        <p className={b('label')}>
          {locale.addressForReplenishment}
        </p>
        <div className={b('input')}>
          <p className={b('value', { special: true })}>{replenishmentAddress}</p>
          <Copy value={replenishmentAddress}>
            <SVG className={b('copy-icon').toString()} svgProps={{ svg: copySVG }} />
          </Copy>
        </div>
      </div>

      <div className={b('field')}>
        <p className={b('label')}>
          {locale.network}
        </p>
        <div className={b('input')}>
          <p className={b('value')}>{fromCurrency}</p>
        </div>
      </div>

      {replenishmentAddress && <div className={b('qr')}>
        <QRCode value={replenishmentAddress} />
      </div>}

      <p className={b('descriptions')}>
        {locale.agentNeedsToSendFundsToTheSpecifiedAddress}
      </p>

      <div className={b('timer-wrapper')}>
        <SVG className={b('timer-icon').toString()} svgProps={{ svg: timerSVG }} />
        <p className={b('timer-value')}>{locale.refillTimer}</p>
        <p className={b('timer-value')}>{timer}</p>
      </div>

      <div className={b('buttons')}>
        <div className={b('button')}>
          <Button onClick={handlePaidClick} text={locale.imPaid} />
        </div>
        <div className={b('button')}>
          <Button onClick={onCancelClick} text={locale.cancel} />
        </div>
      </div>
    </div>
  );
};

BithidePaymentPay.propTypes = {
  onCancelClick: PT.func,
  onPaidClick: PT.func,
};

export default BithidePaymentPay;
